<svg class="glyph" width="987" height="727" viewBox="0 0 987 727" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 734.905H341.262L734.905 0L1051.3 734.905H624.854L320.628 220.63L0 734.905Z" fill="#4782B6" />
</svg>

<div style="position: absolute; top: 15px; right: 50px">
  <topo-theme-switcher></topo-theme-switcher>
</div>

<div fxLayout="row" fxLayoutAlign="center space-around">
  <div class="box password-box">
    <div fxLayout="column" fxLayoutAlign="center space-around">
      <div fxLayout="row" fxLayoutAlign="center space-around">
        <div>
          <topo-logo></topo-logo>
        </div>
        <div>
          <div class="login-line"></div>
        </div>
        <div>
          <span class="text is-xlarge is-bolder mt-3">{{ (isInvite ? (((expirationStatus$ | async) == 2) ?
          'LOGIN.INVITE_EXPIRED_TITLE' : 'LOGIN.SETUP_PASSWORD') : 'LOGIN.RESET_PASSWORD') | translate }}</span>
        </div>
      </div>

      <ng-container>
        @if ((expirationStatus$ | async) == 0) {
          <div>
            <form [formGroup]="form">
              <div class="form-control-container">
                <input
                  (keyup.enter)="resetPasswordConfirmation()"
                  class="input is-medium"
                  type="password"
                  placeholder="{{ 'LOGIN.PASSWORD' | translate }}"
                  formControlName="newPassword"
                  autocomplete="new-password"
                  />
              </div>
              <div class="form-control-container">
                <input
                  (keyup.enter)="resetPasswordConfirmation()"
                  class="input is-medium"
                  type="password"
                  placeholder="{{ 'LOGIN.RETYPE_PASSWORD' | translate }}"
                  formControlName="passwordConfirm"
                  autocomplete="new-password"
                  />
              </div>
              <div class="form-control-container">
                <h5>{{ 'PASSWORD-POLICY.POLICY' | translate }}</h5>
                <ul class="policy_list">
              <li [ngClass]="{
                'error': (form.get('newPassword').touched || form.get('newPassword').dirty) && form.get('newPassword').errors?.minlength }">
                    {{ 'PASSWORD-POLICY.POLICY-LENGTH' | translate }}
                  </li>
              <li [ngClass]="{
              'error': (form.get('newPassword').touched || form.get('newPassword').dirty) && form.get('newPassword').errors?.specialCharacterValid }">
                    {{ 'PASSWORD-POLICY.POLICY-SPECIAL' | translate }}
                  </li>
              <li [ngClass]="{
                'error': (form.get('newPassword').touched || form.get('newPassword').dirty) && form.get('newPassword').errors?.passwordStrength }">
                    {{ 'PASSWORD-POLICY.POLICY-CHARS' | translate }}
                  </li>
                  @if (form.errors?.passwordMatchError) {
                    <li class="error">
                      {{ 'PASSWORD-POLICY.POLICY-PASSWORD-MATCH' | translate }}
                    </li>
                  }
                </ul>
              </div>
            </form>
          </div>
        }

        @if ((expirationStatus$ | async) == 0) {
          <div style="margin-top: 30px">
            <button [disabled]="!form.valid" class="button is-fullwidth is-primary" (click)="resetPasswordConfirmation()">
              {{ (isInvite ? 'LOGIN.SETUP_PASSWORD' : 'LOGIN.RESET_PASSWORD') | translate }}
            </button>
          </div>
        }

        @if ((expirationStatus$ | async) == 1) {
          <div>
            <br>
              <div class="message">{{ (isInvite ? 'LOGIN.SETUP_PASS_EXPIRED_CODE' : 'LOGIN.RESET_PASS_EXPIRED_CODE') | translate }}</div>
              <br>
                <button class="button is-fullwidth is-primary" (click)="verifyResend()">
                  {{ 'LOGIN.RESEND_CODE' | translate }}
                </button>
              </div>
            }

            @if ((expirationStatus$ | async) == 2) {
              <div>
                <br>
                  <div class="message">{{ 'LOGIN.INVITE_EXPIRED_MSG' | translate }}</div>
                  <br>
                    <button class="button is-fullwidth is-primary" (click)="backToLogin()">
                      {{ 'LOGIN.BACK_TO_LOGIN' | translate }}
                    </button>
                  </div>
                }
              </ng-container>
              <div class="pt-5">
                <topo-app-disclaimer />
              </div>
            </div>
          </div>
        </div>
        <topo-spinner></topo-spinner>
        <topo-confirm
          [isActive]="showConfirm"
          (respond)="confirmResendLinkResponse($event)"
          title="{{ (isInvite ? 'LOGIN.RESEND_SETUP_CONFIRM_TITLE' : 'LOGIN.RESEND_CONFIRM_TITLE') | translate }}"
          message="{{ (isInvite ? 'LOGIN.RESEND_SETUP_CONFIRM_MSG' : 'LOGIN.RESEND_CONFIRM_MSG') | translate }}"
          noText="{{ 'MAP.CONFIRM-NO' | translate }}"
          yesText="{{ 'MAP.CONFIRM-YES' | translate }}"
          icon="icon-check_clear"
        ></topo-confirm>

        <topo-confirm
          [isActive]="showConfirmReset"
          (respond)="confirmResetResponse($event)"
          title="{{ (isInvite ? 'LOGIN.SETUP_PASSWORD' : 'LOGIN.RESET_PASSWORD') | translate }}"
          message="{{ (isInvite ? 'LOGIN.SETUP_PASS_CONFIRM_MSG' : 'LOGIN.RESET_PASS_CONFIRM_MSG') | translate }}"
          noText="{{ 'MAP.CONFIRM-NO' | translate }}"
          yesText="{{ 'MAP.CONFIRM-YES' | translate }}"
          icon="icon-check_clear"
        ></topo-confirm>